
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26ZM13 18C10.2386 18 8 15.7614 8 13C8 10.2386 10.2386 8 13 8C15.7614 8 18 10.2386 18 13C18 15.7614 15.7614 18 13 18Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'RadioDot',
    }) as DefineComponent
    </script>
    